import React from 'react';
import CustomLink from '../components/CustomLink';
import { SUBSCRIPTION_FEES_LINK } from './links';

const DEFAULT_BILLING_PERIOD_VALUE = 4;

const renderAgreementTerms = subscriptionData => {
    const { trialDuration, trial, price, billingPeriod } = subscriptionData;

    if (trialDuration) {
        return (
            <>
                By selecting a payment method and proceeding, you agree to automatic subscription
                renewal. First {trialDuration} {trialDuration === 1 ? 'week' : 'weeks'} is {trial.price} now, then {price} every{' '}
                {billingPeriod?.value || DEFAULT_BILLING_PERIOD_VALUE} weeks until you cancel in settings
                before the end of the current period. Learn more in{' '}
                <CustomLink to={SUBSCRIPTION_FEES_LINK} target='_blank'>
                    Subscription terms
                </CustomLink>
                .
            </>
        );
    }

    return (
        <>
            By selecting a payment method and proceeding, you agree to automatic subscription
            renewal. You will be charged {price} now and every{' '}
            {billingPeriod?.value || DEFAULT_BILLING_PERIOD_VALUE} weeks until you cancel in settings
            before the end of the current period. Learn more in{' '}
            <CustomLink to={SUBSCRIPTION_FEES_LINK} target='_blank'>
                Subscription terms
            </CustomLink>
            .
        </>
    );
};

export {
    renderAgreementTerms
};
